document.addEventListener('DOMContentLoaded', () => {
  const scope = document.querySelector('[shopify-search]') || document;

  function initializePriceRangeSlider() {
    const containers = scope.querySelectorAll('.custom-range');
    if (!containers || containers.length === 0) return;

    containers.forEach(container => {
      const rangeInputs = container.querySelectorAll('.range-input input');
      if (!rangeInputs || rangeInputs.length < 2) return;

      const priceInputs = container.querySelectorAll('.price-input-show');
      const progress = container.querySelector('.slider .progress');
      const ticks = container.querySelectorAll('.ticks .tick');
      const minFilter = container.querySelector('.min-price-filter');
      const maxFilter = container.querySelector('.max-price-filter');

      let priceGap = 1;
      let lastActive = 'max';

      const parseIntSafe = (value, fallback = NaN) => {
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? fallback : parsed;
      };

      const clamp = (num, min, max) => Math.min(max, Math.max(min, num));

      const getBounds = () => {
        const boundMin = Number.isFinite(Number(container?.dataset?.min))
          ? Number(container.dataset.min)
          : parseIntSafe(rangeInputs[0].min, 0);

        const boundMax = Number.isFinite(Number(container?.dataset?.max))
          ? Number(container.dataset.max)
          : parseIntSafe(rangeInputs[1].max, 0);

        const min = Math.min(boundMin, boundMax);
        const max = Math.max(boundMin, boundMax);
        const range = Math.max(1, max - min);

        return { min, max, range };
      };

      const getValue = (el) => {
        if (!el) return NaN;
        const tag = el.tagName ? el.tagName.toUpperCase() : '';
        if (tag === 'INPUT' || tag === 'TEXTAREA') {
          if (el.value === '' || el.value === null || el.value === undefined) return NaN;
          const parsed = parseInt(el.value, 10);
          return Number.isNaN(parsed) ? NaN : parsed;
        }
        const parsed = parseInt(el.innerHTML, 10);
        return Number.isNaN(parsed) ? NaN : parsed;
      };

      const setValue = (el, val) => {
        if (!el) return;
        const tag = el.tagName ? el.tagName.toUpperCase() : '';
        if (tag === 'INPUT' || tag === 'TEXTAREA') el.value = val;
        else el.innerHTML = val;
      };

      const updateProgress = (minVal, maxVal) => {
        if (!progress) return;
        const { min, range } = getBounds();
        const minPercent = clamp(((minVal - min) / range) * 100, 0, 100);
        const maxPercent = clamp(((maxVal - min) / range) * 100, 0, 100);

        progress.style.left = `${minPercent}%`;
        progress.style.right = `${100 - maxPercent}%`;
        progress.style.width = '';
      };

      const applyValues = ({ minVal, maxVal, source = 'init' }) => {
        const { min, max } = getBounds();

        let nextMin = clamp(parseIntSafe(minVal, min), min, max);
        let nextMax = clamp(parseIntSafe(maxVal, max), min, max);

        if ((nextMax - nextMin) < priceGap) {
          if (source === 'min') nextMin = nextMax - priceGap;
          else if (source === 'max') nextMax = nextMin + priceGap;
          else {
            if (nextMin + priceGap <= max) nextMax = nextMin + priceGap;
            else nextMin = nextMax - priceGap;
          }
        }

        nextMin = clamp(nextMin, min, max);
        nextMax = clamp(nextMax, min, max);

        rangeInputs[0].value = nextMin;
        rangeInputs[0].setAttribute('data-term', nextMin);
        rangeInputs[1].value = nextMax;

        if (priceInputs && priceInputs.length >= 2) {
          setValue(priceInputs[0], nextMin);
          setValue(priceInputs[1], nextMax);
        }

        if (minFilter) minFilter.value = nextMin;
        if (maxFilter) maxFilter.value = nextMax;

        updateProgress(nextMin, nextMax);
      };

      // Initial values: prefer hidden filter inputs if present
      const hasMin = minFilter && minFilter.value !== '';
      const hasMax = maxFilter && maxFilter.value !== '';
      const initialMin = hasMin ? parseIntSafe(minFilter.value, getBounds().min) : parseIntSafe(rangeInputs[0].value, getBounds().min);
      const initialMax = hasMax ? parseIntSafe(maxFilter.value, getBounds().max) : parseIntSafe(rangeInputs[1].value, getBounds().max);
      applyValues({ minVal: initialMin, maxVal: initialMax, source: 'init' });

      // Number inputs
      if (priceInputs && priceInputs.length >= 2) {
        priceInputs.forEach(el => {
          el.addEventListener('focus', () => {
            if (el.classList.contains('input-min')) lastActive = 'min';
            if (el.classList.contains('input-max')) lastActive = 'max';
          });

          el.addEventListener('input', (e) => {
            const source = e.target.classList.contains('input-min') ? 'min' : 'max';
            lastActive = source;

            const { min, max } = getBounds();
            const currentMin = parseIntSafe(rangeInputs[0].value, min);
            const currentMax = parseIntSafe(rangeInputs[1].value, max);

            const typedMin = getValue(priceInputs[0]);
            const typedMax = getValue(priceInputs[1]);

            applyValues({
              minVal: Number.isFinite(typedMin) ? typedMin : currentMin,
              maxVal: Number.isFinite(typedMax) ? typedMax : currentMax,
              source
            });
          });

          el.addEventListener('change', (e) => {
            const source = e.target.classList.contains('input-min') ? 'min' : 'max';
            lastActive = source;

            const { min, max } = getBounds();
            const currentMin = parseIntSafe(rangeInputs[0].value, min);
            const currentMax = parseIntSafe(rangeInputs[1].value, max);

            const typedMin = getValue(priceInputs[0]);
            const typedMax = getValue(priceInputs[1]);

            applyValues({
              minVal: Number.isFinite(typedMin) ? typedMin : currentMin,
              maxVal: Number.isFinite(typedMax) ? typedMax : currentMax,
              source
            });
          });
        });
      }

      // Range inputs
      rangeInputs.forEach(input => {
        input.addEventListener('input', (e) => {
          const source = e.target.classList.contains('range-min') ? 'min' : 'max';
          lastActive = source;

          const { min, max } = getBounds();
          const minVal = parseIntSafe(rangeInputs[0].value, min);
          const maxVal = parseIntSafe(rangeInputs[1].value, max);

          applyValues({ minVal, maxVal, source });
        });
      });

      // Ticks
      if (ticks && ticks.length > 0) {
        ticks.forEach(tick => {
          tick.addEventListener('click', () => {
            const tickValue = parseIntSafe(tick.dataset.value, NaN);
            if (!Number.isFinite(tickValue)) return;

            const { min, max } = getBounds();
            const currentMin = parseIntSafe(rangeInputs[0].value, min);
            const currentMax = parseIntSafe(rangeInputs[1].value, max);

            let source = lastActive;
            if (source !== 'min' && source !== 'max') {
              const dMin = Math.abs(tickValue - currentMin);
              const dMax = Math.abs(tickValue - currentMax);
              source = dMin <= dMax ? 'min' : 'max';
            }

            const nextMin = source === 'min' ? tickValue : currentMin;
            const nextMax = source === 'max' ? tickValue : currentMax;

            applyValues({ minVal: nextMin, maxVal: nextMax, source });
          });
        });
      }
    });
  }

  initializePriceRangeSlider();


    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){

            control.addEventListener('click', () => {

                if(el.classList.contains("open")){
                    el.classList.remove("open")
                } else {
                    custom_filters.forEach(f => f.classList.remove("open"))
                    el.classList.add("open")
                }

            })
        }
    })

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if(mobile_control && filter_body){
        mobile_control.addEventListener('click', () => {
            // rotate svg
            if(mobile_control.classList.contains("open")){
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if(filter_body.classList.contains("open")){
                filter_body.classList.remove("open")
            } else {
                filter_body.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');
    const search_grid = document.querySelector('[shopify-search] .search-wrapper');

    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            if (search_grid) search_grid.classList.add("loading");
        });
    });

    // Desktop: do NOT auto-apply on change when an "Apply filters" button is present.
    // Instead, keep selections in the form and only submit when Apply is clicked.
    if (window.innerWidth >= 768) {
        const filter_inputs = document.querySelectorAll('[shopify-search] [filter-wrapper] select, [shopify-search] [filter-wrapper] input');
        const filter_form = document.querySelector('[shopify-search] .filter-container');
        const submitBtn = document.querySelector('[shopify-search] #apply-filters');

        const requiresApply = !!submitBtn;

        const isIgnorableInput = (input) => {
            if (!input) return true;
            if (input.classList && input.classList.contains('js-filtered-products-count')) return true;
            if (input.hasAttribute && input.hasAttribute('data-default-availability-filter')) return true;
            return false;
        };

        if (!requiresApply && filter_inputs && filter_form && search_grid) {
            // Preserve existing "instant apply" mode when there is no Apply button
            filter_inputs.forEach(input => {
                if (isIgnorableInput(input)) return;
                input.addEventListener('change', () => {
                    search_grid.classList.add("loading");
                    filter_form.submit();
                });
            });
        }
    }

    // Submit form (Apply filters CTA)
    const submitBtn = document.querySelector('[shopify-search] #apply-filters');
    const filter_form = document.querySelector('[shopify-search] .filter-container');
    if (submitBtn && filter_form) {
        submitBtn.addEventListener('click', function () {
            console.log('submitting form');
            filter_form.submit();
        });
    }

    // Sort dropdown arrow rotation on focus/blur
    const sortSelect = document.getElementById('SortBy');
    const sortArrow = sortSelect ? sortSelect.parentElement.querySelector('.sort-arrow') : null;

    if(sortSelect && sortArrow) {
        sortSelect.addEventListener('focus', () => {
            sortArrow.style.transform = 'rotate(180deg)';
        });
        sortSelect.addEventListener('blur', () => {
            sortArrow.style.transform = 'rotate(90deg)';
        });
    }
});